import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f1bca5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-approver" }
const _hoisted_2 = { class: "approver-item" }
const _hoisted_3 = { class: "item-info" }
const _hoisted_4 = { class: "info-img" }
const _hoisted_5 = { class: "info-text" }
const _hoisted_6 = { class: "info-name" }
const _hoisted_7 = { class: "info-position" }
const _hoisted_8 = { class: "item-state" }
const _hoisted_9 = {
  key: 0,
  class: "approver-down"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popupShow) = $event)),
      closeable: "",
      position: "right",
      style: { height: '100%' },
      onClose: _ctx.handleClose
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_van_image, {
                    round: "",
                    width: "40px",
                    height: "40px",
                    src: item.head_pic
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.department_name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.state_name), 1)
            ]),
            (index + 1 != _ctx.listData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_van_icon, { name: "down" })
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ]))
}